import TypographyStyle from "@assets/typography";
import { StyleSheet } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { colors } from "theme";

const useStyles = CreateResponsiveStyle(
  {
    container: { 
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
    },
    linearStyle_portrait: { display: "none" },

    maintenance_logo_container: {
      flexDirection: 'row', 
      justifyContent: 'center', 
      alignItems: 'center', 
      bottom: 50, 
    },
    t_logo_container: {
      marginTop: "20%",
      width: '60%', 
      alignItems: 'center',
    },
    t_logo: {
      textAlign: 'center',
      fontFamily: "DMSans",
      fontWeight: "500",
      paddingTop: 0,
      fontSize: 70,
      lineHeight: 75,
      marginTop: 27,
      marginBottom: 60,
      color: colors.white, 
    },
    maintenance_message: {
      textAlign: 'center',
      color: '#ffffff',
      width: 600,
      // paddingRight: 10,
      fontSize: 24,
    },

    //IMAGE BG
    i_bg: {
      ...StyleSheet.absoluteFillObject,
      width: "100%",
      height: "100%",
    },
    // BACKGROUND COMPONENT
    linearStyle: {
      position: "absolute",
      zIndex: -1,
      width: "100%",
      height: "100%",
    },

    copyRightStyle: StyleSheet.flatten([
      TypographyStyle.copyRightText,
      {
        alignSelf: "center",textAlign: "center", 
        color: colors.white },
    ]),
    unawaProductStyle : StyleSheet.flatten([
      TypographyStyle.copyRightText,
      {  marginTop: 100,
        alignSelf: "center", textAlign: "center", 
        width: 410,
        fontSize: 10,
        color: colors.white },
    ]),
    copyRightBtnStyle: StyleSheet.flatten([TypographyStyle.copyRightButton, {
      fontSize: 10,
    }]),


  },
  {
    [DEVICE_SIZES.XL]: {
      unawaProductStyle: {
        marginTop: 200,
      }
    },
    [DEVICE_SIZES.LG]: {
      t_logo: { fontSize: 50, lineHeight: 55, marginBottom: 40 },
      unawaProductStyle: {
        marginTop: 150,
      }
    },
    [DEVICE_SIZES.MD]: {
      t_logo: { 
        fontSize: 35, 
        lineHeight: 35, 
        marginTop: 15, 
        fontWeight: "500",
        // textAlign: "center"
      },
      linearStyle_portrait: { display: "none" },
    }, 
    [DEVICE_SIZES.SM]: {
      t_logo_container: {
        width: '55%', 
      },
      t_logo: { 
        fontSize: 25, 
        lineHeight: 25, 
        marginTop: 15, 
        fontWeight: "500",
        // textAlign: "center"
      },

      //portrait
      linearStyle_portrait: { display: "none" },
    },
    [DEVICE_SIZES.XS]: {
      maintenance_logo_container: {
        flexDirection: 'column', 
        bottom: 20,
      },
      t_logo_container: {
        width: '90%', 
        marginLeft: 20,
        marginTop: 30,
      },
      t_logo: { 
        fontSize: 20, 
        lineHeight: 25, 
        marginTop: 15, 
        fontWeight: "500",
        // textAlign: "center"
      },
      linearStyle_portrait: { display: "none" },
    },
  }
);

export default useStyles;